import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'
import moment from 'moment'
import { range, each } from 'lodash'
import $ from 'jquery'; 

import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import HelpAlert from '../components/HelpAlert'
import DataTable from '../components/DataTable'

import { Select, Spin, message } from 'antd'
const { Option } = Select


class Report6 extends Component {

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        year: moment().year(),
        data: null,
        loading: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'reports/6/' + this.state.year 
        }).then((data) => {
            this.setState({
                data: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate() {
        if (!this.state.loading && this.state.data) {
            const data = this.state.data.total
            let tfoot = '<tfoot class="ant-table-thead"><tr><th>Total</th>'
            each(moment.months(), (month, index) => (
                tfoot += '<th>' + (data.months[index + 1] || 0) + '</th>'
            ))
            tfoot += "<th>" + data.total + "</th></tr></tfoot>"
            $(".table-all table").append(tfoot)
        }
    }

    onChangeYear = (value) => {
        this.setState({ year: value }, this.fetch)
    }

    render() {
        const { data, loading, year } = this.state

        const columns = [
            { title: "reports.report6.doctor", dataIndex: "name", type: "string", sorter: true },
        ]
        each(moment.months(), (month, index) => (
            columns.push({ title: month, formatTitle: false, key: month, type: "number", dataIndex: "months[" + (index + 1) + "]", sorter: true })
        ))
        columns.push({ title: "reports.report6.total", type: "number", dataIndex: "total", sorter: true })


        return (
            <div>
                <h1><FaIcon icon="chart-bar" fixedWidth /> <FormattedHTMLMessage id="reports.report6.title" /></h1>
                <div className="action-bar">
                    <Select defaultValue={year} style={{ width: 120 }} onChange={this.onChangeYear}>
                        { range(2016, moment().year() + 1).map(year => <Option key={year} value={year}>{year}</Option>) }
                    </Select>
                </div>
                <HelpAlert style={{ marginTop: '25px', marginBottom: '25px' }} message="reports.report6.helpAlert" />
                {
                    loading 
                        ? <div style={{ textAlign: 'center', marginTop: '50px' }}><Spin size="large" /></div>
                        : !data || data.data.length === 0
                            ? <div className="message" style={{ marginTop: "45px" }}>
                                <FaIcon icon="exclamation-circle" size="8x" />
                                <br /><br />
                                <span style={{ fontSize: "35px" }}><FormattedMessage id="reports.misc.noData" /></span>
                            </div>
                            : <DataTable columns={columns} dataSource={data.data} rowKey="doctor" size="middle" className="table-all" export={{ format: "landscape" }} />
                }
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default injectIntl(connect(mapStateToProps)(Report6))


// WEBPACK FOOTER //
// ./src/views/Report6.js